import React, {useMemo} from 'react';
import {Chip} from '@mui/material';
import type {PartValueRenderer} from 'schema/types';
import {type TaskType as TaskTypeType, TaskTypes} from 'services/tasks/types';
import type {ColorMode} from 'theme/types';
import {useLocalization} from 'localization';
import {ColorPalette, px2rem} from 'theme';
import {NoWrap, Text} from 'components';

const spotColors: {[key in TaskTypeType]: string} = {
  new: ColorPalette.status.new,
  pre: ColorPalette.status.pre,
  control: ColorPalette.status.control,
  change: ColorPalette.status.change,
  ml: ColorPalette.status.ml,
  mottak: ColorPalette.status.mottak,
};

const spotTextColors: {[key in TaskTypeType]: ColorMode} = {
  new: 'main',
  pre: 'main',
  control: 'main',
  change: 'main',
  ml: 'light',
  mottak: 'main',
};

export const TaskType: PartValueRenderer = ({value}) => {
  const {tLoose} = useLocalization();

  const types = value
    ? Array.isArray(value)
      ? (value as TaskTypeType[])
      : []
    : [];
  type TagTitleMap = {[key in TaskTypeType]: string};
  const tagTitles = useMemo(
    () =>
      TaskTypes.reduce<TagTitleMap>((acc, tag) => {
        acc[tag] = tLoose(`entity.task.type.short.${tag}`);
        return acc;
      }, {} as TagTitleMap),
    [tLoose],
  );

  return (
    <NoWrap>
      {types.map((tt: TaskTypeType) => {
        const title = tagTitles[tt];

        return (
          <Chip
            key={tt}
            label={
              <Text
                variant="body2"
                textTransform="none"
                mode={spotTextColors[tt]}>
                {title}
              </Text>
            }
            sx={{
              background: spotColors[tt],
              height: px2rem(29),
            }}
          />
        );
      })}
    </NoWrap>
  );
};
